import type { DocumentDetailsRightPanelConfigData } from './useDocumentDetailsRightPanelConfigData.types';
import type { GlobalState } from 'shared/reducers';

import * as authSelectors from 'shared/features/auth/auth.selectors';
import * as rightPanelSelectors from 'shared/features/rightPanel/rightPanel.selectors';
import * as userSelectors from 'shared/features/user/user.selectors';

import { OVERLAY_TYPES } from 'shared/features/rightPanel/rightPanel.constants';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export const useDocumentDetailsRightPanelConfigData = (): DocumentDetailsRightPanelConfigData => {
  const reduxState = useSelector<GlobalState, DocumentDetailsRightPanelConfigData['reduxState']>(
    state => ({
      isAuthenticated: authSelectors.getUserAuthenticatedState(state),
      currentUserId: userSelectors.getUserId(state),

      rightPanel: {
        type: rightPanelSelectors.getRightPanelType(state as never),
        isClosable: rightPanelSelectors.getRightPanelIsClosable(state as never),
        documentId: rightPanelSelectors.getRightPanelDocumentId(state as never),
        documentDetailsActiveTabKey: rightPanelSelectors.getDocumentDetailsActiveTabKey(
          state as never
        ),
        isOverlayOpen: rightPanelSelectors.getOverlayOpenState(state),
        shouldReopenOverlay: rightPanelSelectors.getOverlayReopenToggle(state),
        overlayType: rightPanelSelectors.getOverlayType(state) || OVERLAY_TYPES.PDF
      }
    })
  );

  const formattedData = useMemo(
    () => ({
      isUserLoading: !reduxState.currentUserId && reduxState.isAuthenticated // we should display doc in right panel for unauthorized users
    }),
    [reduxState.currentUserId, reduxState.isAuthenticated]
  );

  return {
    reduxState,
    formattedData
  };
};
